import { render, staticRenderFns } from "./joinMount.vue?vue&type=template&id=165a06ea&scoped=true"
import script from "./joinMount.vue?vue&type=script&lang=js"
export * from "./joinMount.vue?vue&type=script&lang=js"
import style0 from "./joinMount.vue?vue&type=style&index=0&id=165a06ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165a06ea",
  null
  
)

export default component.exports